export const YOUTUBE = "YOUTUBE";
export const VIMEO = "VIMEO";
export const ZOOM = "ZOOM";
export const BRIGHTCOVE = "BRIGHTCOVE";
export const EMPTY = 'EMPTY';

const YOUTUBE_REGEX = "youtube.com";
const YOUTUBE_SHORT_LINK_REGEX = "youtu.be";
const VIMEO_REGEX = "vimeo.com";
const BRIGHTCOVE_REGEX = "brightcove";
const ZOOM_REGEX = "zoom.us";

const isYotubeUrl = (url: string) => {
  if (url.includes(YOUTUBE_REGEX) || url.includes(YOUTUBE_SHORT_LINK_REGEX)) {
    return true;
  } else {
    return false;
  }
};

const isVimeoUrl = (url: string) => {
  if (url.includes(VIMEO_REGEX)) {
    return true;
  } else {
    return false;
  }
};

const isBrightcoveUrl = (url: string) => {
  if (url.includes(BRIGHTCOVE_REGEX)) {
    return true;
  } else {
    return false;
  }
};

const isZoomUrl = (url: string) => {
  if (url.includes(ZOOM_REGEX)) {
    return true;
  } else {
    return false;
  }
};

const isEmpty = (url: string) => {
  if(!url) {
    return true;
  } else {
    return false
  }
}

export const urlDetector = (url: string) => {
  if (isYotubeUrl(url)) return YOUTUBE;
  if (isVimeoUrl(url)) return VIMEO;
  if (isBrightcoveUrl(url)) return BRIGHTCOVE;
  if (isZoomUrl(url)) return ZOOM;
  if (isEmpty(url)) return EMPTY;
};
